//v1.0
//Loader group for grouping to together 1 or more Loaders
//Useful for situations when a load of different things need to be loaded before it can be shown
import { Loader } from './Loader';

export class LoaderGroup {
	public id: string;
	public onComplete: Function;
	public onProgress: Function;
	public onError: Function;

	private _group: Array<Loader> = [];

	public add(...loaders: Loader[]): void {
		this._group = this._group.concat(loaders);
	}

	public load(): void {
		for (let i = 0; i < this._group.length; i++) {
			this._group[i].setLoaderGroupCallbacks(
				() => this._onAssetComplete(),
				(error) => this._onError(error)
			);
			this._group[i].load();
		}
	}

	//private
	//--------------------------------------------------------
	//--------------------------------------------------------
	//--------------------------------------------------------
	//--------------------------------------------------------

	//Single loader has completed
	private _onAssetComplete(data: any = null): void {
		let totalAssets: number = this._getTotalAssets();
		let loadedAssets: number = this._getLoadedAssets();
		let ratio = loadedAssets / totalAssets;


		if (this.onProgress) {
			this.onProgress({
				id: this.id,
				ratio: ratio,
				total: totalAssets,
				loaded: loadedAssets
			});
		}

		if (totalAssets === loadedAssets) {
			this._groupComplete();
		}
	}

	//The whole group has completed:
	private _groupComplete(): void {
		if (this.onComplete) {
			this.onComplete(this.id);
		}

		this._destroy();
	}

	//On assets error:
	private _onError(error: string): void {
		if (this.onError) {
			this.onError(error);
		}
	}

	//Get total assets. This can be more than the amout of loaders as ImageLoader can have many images
	private _destroy(): void {
		return;
		if (!this._group) {
			return;
		}

		for (var i = 0; i < this._group.length; i++) {
			this._group[i].destroy();
		}

		this._group = null;
	}

	//Get total assets in the whole group
	private _getTotalAssets(): number {
		let count = 0;
		for (let i = 0; i < this._group.length; i++) {
			count += this._group[i].getTotalAssets();
		}
		return count;
	}

	//Get total assets in the whole group
	private _getLoadedAssets(): number {
		let count = 0;
		for (let i = 0; i < this._group.length; i++) {
			count += this._group[i].getLoadedAssets();
		}
		return count;
	}
}
